import React, { useEffect, useState } from 'react'
import FormRow from '../../../../components/FormRow'
import FormCol from '../../../../components/FormCol'
import Typography from '@material-ui/core/Typography'
import {
  SimpleForm,
  NumberInput,
  BooleanInput,
  SelectInput,
  TextInput,
  CheckboxGroupInput,
  DateInput,
  Toolbar,
  SaveButton,
  useNotify,
  useRefresh,
  Edit,
  Button,
  useGetOne,
  RefreshButton,
} from 'react-admin'
import {
  apartmentHasChoices,
  furnitureChoices,
  includedCostChoices,
  propertyTypeCoices,
  bathroomTypeChoices,
  floorChoices,
  houseForChoices,
  depositChoices,
  useStyles,
} from './common'
import StyledInput from '../../../../components/StyledInput'
import PropertyAddressInput from '../../../../components/PropertyAddressInput'
import Notes from '../../../../components/Notes/Notes'

export const EditProperty = (props) => {
  const refresh = useRefresh()
  const notify = useNotify()
  const classes = useStyles()
  const { data, loading } = useGetOne('properties', props.record.property_id)
  const [notes, setNotes] = useState()

  useEffect(() => {
    setNotes(data?.notes)
  }, [data])

  const onSuccess = () => {
    notify('Property Updated', 'info', { smart_count: 1 }, true)
    refresh()
  }

  const onFailure = (error) => {
    notify(`An Error occured updating property  ${error}`, 'error', { smart_count: 1 }, true)
    refresh()
  }

  const handleNotesChanged = (notes) => {
    setNotes(notes)
  }

  const handleClickRefresh = () => {
    refresh()
    notify('Property Refreshed', 'info', { smart_count: 1 }, true)
  }

  const CustomToolbar = (props) => {
    return (
      <Toolbar {...props}>
        <SaveButton
          onSuccess={onSuccess}
          onFailure={onFailure}
          submitOnEnter={false}
          transform={(data) => ({ ...data, notes })}
        />
        <span className={classes.spacer} />
        <RefreshButton onClick={handleClickRefresh} />
        <span className={classes.spacer} />
        {props.record.id && (
          <Button
            color="primary"
            href={`${process.env.REACT_APP_ADMIN_PANEL}/properties/${props.record.id}`}
            target="_blank"
            label="Vai al pannello admin"
          />
        )}
      </Toolbar>
    )
  }
  return (
    <Edit {...props} resource="properties">
      <SimpleForm {...props} warnWhenUnsavedChanges toolbar={<CustomToolbar />}>
        <FormRow>
          <FormCol item lg={1}>
            <StyledInput component={TextInput} source="id" disabled />
          </FormCol>
          <FormCol item lg={1}>
            <StyledInput component={TextInput} source="owner_id" disabled />
          </FormCol>
        </FormRow>
        <FormRow>
          <FormCol item xs={4}>
            <StyledInput component={SelectInput} source="type" choices={propertyTypeCoices} />
          </FormCol>
          <FormCol item xs={4}>
            <StyledInput component={BooleanInput} label="Exclusive" source="exclusive" />
          </FormCol>
        </FormRow>
        <FormRow>
          <Typography variant="h6" gutterBottom>
            Listing
          </Typography>
        </FormRow>
        <FormRow>
          <FormCol xs={12} sm={12} md={6} lg={6} xl={6}>
            <StyledInput component={TextInput} source="listing.title" label="title" />
          </FormCol>
        </FormRow>
        <FormRow>
          <FormCol xs={12} sm={12} md={8} lg={8} xl={8}>
            <StyledInput component={TextInput} multiline="true" source="listing.description" label="description" />
          </FormCol>
        </FormRow>
        <FormRow>
          <Typography variant="h6" gutterBottom>
            Address
          </Typography>
        </FormRow>
        <FormRow>
          <FormCol xs={12} sm={12} md={8} lg={8} xl={8}>
            <PropertyAddressInput />
          </FormCol>
        </FormRow>
        <FormRow>
          <Typography variant="h6" gutterBottom>
            Details
          </Typography>
        </FormRow>
        <FormRow>
          <FormCol>
            <StyledInput
              component={SelectInput}
              source="details.bathoroms_type"
              choices={bathroomTypeChoices}
              label="bathoroms type"
            />
          </FormCol>
          <FormCol>
            <StyledInput component={SelectInput} choices={floorChoices} source="details.floor" label="floor" />
          </FormCol>
          <FormCol>
            <StyledInput component={NumberInput} source="details.number_of_bathrooms" label="number of bathrooms" />
          </FormCol>
          <FormCol>
            <StyledInput component={NumberInput} source="details.number_of_beds" label="number of beds" />
          </FormCol>
          <FormCol>
            <StyledInput component={NumberInput} source="details.size_sqm" label="size sqm" />
          </FormCol>
          <FormCol>
            <StyledInput component={NumberInput} source="details.total_bedrooms" label="total bedrooms" />
          </FormCol>
          <FormCol lg={12}>
            <StyledInput
              component={CheckboxGroupInput}
              source="details.furnitures"
              label="Furnitures"
              row={true}
              choices={furnitureChoices}
            />
          </FormCol>
          <FormCol lg={12}>
            <StyledInput
              component={CheckboxGroupInput}
              source="details.apartment_has"
              label="Apartment has"
              row={true}
              choices={apartmentHasChoices}
            />
          </FormCol>
        </FormRow>
        <FormRow>
          <Typography variant="h6" gutterBottom>
            Pricing
          </Typography>
        </FormRow>
        <FormRow>
          <FormCol>
            <StyledInput component={NumberInput} source="pricing.rent_price" label="rent price" />
          </FormCol>
          <FormCol>
            <StyledInput component={NumberInput} source="pricing.other_costs" label="other costs" />
          </FormCol>
          <FormCol>
            <StyledInput component={TextInput} source="pricing.currency" label="currency" disabled />
          </FormCol>
        </FormRow>
        <FormRow>
          <Typography variant="h6" gutterBottom>
            Rules
          </Typography>
        </FormRow>
        <FormRow>
          <FormCol>
            <StyledInput component={DateInput} source="rules.availability_start_date" label="availability start date" />
          </FormCol>
          <FormCol>
            <StyledInput component={NumberInput} source="rules.months_notice_termination" label="months notice termination" />
          </FormCol>
          <FormCol>
            <StyledInput component={NumberInput} source="rules.minimum_stay" label="minimum stay (months)" />
          </FormCol>
          <FormCol>
            <StyledInput component={SelectInput} choices={houseForChoices} source="rules.house_for" label="house for" />
          </FormCol>
          <FormCol>
            <StyledInput component={SelectInput} choices={depositChoices} source="rules.deposit" label="deposit" />
          </FormCol>
          <FormCol>
            <StyledInput component={BooleanInput} source="rules.pets_allowed" label="pets allowed" />
          </FormCol>
          <FormCol xs={12} sm={12} md={12} lg={12}>
            <StyledInput
              component={CheckboxGroupInput}
              source="rules.included_costs"
              label="Included cost"
              choices={includedCostChoices}
            />
          </FormCol>
        </FormRow>
        <FormRow>
          <Typography variant="h6" gutterBottom>
            Notes
          </Typography>
        </FormRow>
        <FormRow>
          <FormCol xs={12} sm={12} md={12} lg={12} xl={12}>
            <Notes data={data?.notes} loading={loading} onNotesChanged={handleNotesChanged} />
          </FormCol>
        </FormRow>
      </SimpleForm>
    </Edit>
  )
}
